const cindieBookingUrl = 'https://twnhub.online/book/cindie?globalServiceId=2';
const aquieraBookingUrl = 'https://twnhub.online/book/aquiera?globalServiceId=2';

export const ongoingSupportPages = {
  cindie: {
    name: 'Cindie Phanhmixay',
    title: 'Spiritual Life Coach',
    photo: '/practitioner-thumbnails/51ff6aa15db6237a77ac.webp',
    profilePath: '/practitioners/cindie-phanhmixay',
    heroMessage:
      'Empowering women to discover their true potential, find their authentic selves and navigate through life’s challenges.',
    introduction: {
      category: 'Spiritual Life Coaching',
      title: 'Your Path to Radiance: Healing, Alignment, and Expansion',
      body:
        'Personalized 1:1 sessions to help you release energetic blocks, realign with your highest self, and step fully into your power. Whether you’re seeking a quick reset or lasting transformation, these coaching options are designed to support your manifestation journey and unlock greater love, success, and abundance. Choose the package that meets you where you are—and get ready to attract what you truly desire with clarity and confidence.',
      bookingUrl: cindieBookingUrl,
    },
    offerings: [
      {
        title: 'Personal Manifestation',
        body:
          'Focused sessions designed to clear energetic blocks and realign with your goals. You’ll receive personalized strategies, intuitive insight, and energy support to help you manifest with clarity and confidence. Perfect for a quick reset or breakthrough when you’re feeling stuck or out of sync.',
      },
      {
        title: 'The Aligned CEO',
        subtitle: 'Create the Life & Business of Your Dreams',
        body:
          'Private coaching sessions for entrepreneurs, coaches, and visionaries ready to align their mindset, energy, and business strategy. You’ll gain clarity on what’s holding you back, receive a personalized CEO alignment roadmap, and walk away with daily rituals to stay in flow. This session helps you lead with confidence, attract aligned clients, and grow your business without burnout. It’s time to become the CEO of your life, and build success on your terms.',
      },
    ],
  },
  aquiera: {
    name: 'Aquiera Halsey, MPH',
    title: 'Worthiness Coach, Spiritual Life Coach, & Hypnotist',
    photo: '/practitioner-thumbnails/a49e5b8550f5d096b56e.webp',
    profilePath: '/practitioners/aquiera-halsey-mph',
    heroMessage: 'You Are Worthy!',
    heroSubheading: 'THE WORTHINESS CONTINUUM',
    offerings: [
      {
        title: 'Worthiness Boost',
        body:
          'Through 6 transformative one-hour sessions, you’ll reclaim your worth, deepen your spiritual connection, and gain clarity with Aquiera’s intuitive, structured guidance. Each session is designed to support healing, self-discovery, and daily integration, empowering you to move forward with renewed confidence and purpose.',
      },
      {
        title: 'The Intuition Code',
        body:
          'An 8-session journey into intuitive power, spiritual protection, and self-trust. Blending psychic medium practices, shamanic journeying, and metaphysical tools like timeline matrix reconstruction and future self anchoring, this program helps you reconnect with your inner guidance system. It’s especially affirming for people who often second-guess or feel disconnected from their intuition. Each session offers grounded, mystical practices to help you feel protected, clear, and confident in your knowing.',
      },
      {
        title: 'Anxiety Alchemy',
        body:
          'An 8-session coaching journey that helps sensitive, intuitive people transform anxiety into inner clarity and strength. With practices like breathwork, energy clearing, astrology, and shadow integration, you’ll learn to regulate your emotions and reclaim your worth. This program is especially affirming for LGBTQ+ clients and anyone seeking a safe, spiritually grounded space to heal and grow.',
      },
      {
        title: 'Spiritual Life Coaching',
        body:
          'A transformational journey offered in 4, 6, or 10 one-hour sessions, each designed to provide clarity, breakthroughs, and deep spiritual insight. Through intuitive guidance and practical tools, you’ll work through emotional and energetic blocks, align with your purpose, and build momentum toward your highest potential. Ideal for those ready to commit to lasting growth, inner healing, and soul-centered transformation.',
      },
    ],
    hypnosis: {
      title: 'HYPNOSIS OFFERINGS',
      subtitle: '(Clinical & Metaphysical Hypnosis)',
      introduction:
        'I offer spiritually integrated clinical hypnosis rooted in metaphysics, nervous system regulation, and subconscious re-patterning. All hypnosis work begins with a consultation to understand each client’s unique needs before creating a customized approach.',
      focusAreas: [
        {
          title: 'Self-Worth & Identity Reclamation',
          body: 'Releasing subconscious beliefs tied to unworthiness, shame, invisibility, or over-responsibility.',
        },
        {
          title: 'Ancestral & Generational Pattern Healing',
          body:
            'Working with inherited survival patterns, emotional burdens, and ancestral imprints that impact present-day behavior and self-concept.',
        },
        {
          title: 'Burnout, Emotional Suppression & Nervous System Support',
          body:
            'Supporting clients who feel chronically depleted, disconnected, or emotionally shut down due to long-term stress or caretaking roles.',
        },
        {
          title: 'Attachment Repair & Relationship Patterns',
          body:
            'Addressing subconscious attachment wounds, relationship anxiety, and patterns rooted in early conditioning.',
        },
        {
          title: 'Spiritual Integration & Soul Alignment',
          body:
            'Helping clients integrate spiritual experiences, intuitive awakenings, or life transitions into a grounded, embodied sense of self.',
        },
        {
          title: 'Quantum & Timeline-Based Hypnosis',
          body:
            'Exploring subconscious timelines, identity shifts, and future-oriented re-patterning aligned with purpose and embodiment.',
        },
      ],
      bookingUrl: 'https://twnhub.online/book/aquiera?globalServiceId=3',
      note:
        '*All hypnosis services are offered through an initial consultation to ensure ethical alignment, clarity, and client readiness before building a personalized package.',
    },
  },
};
